module.exports = __webpack_public_path__ + "img/GEORGIA-FS-CW.a5e54c86.svg";